import { createSlice, PayloadAction } from '@reduxjs/toolkit';

export interface PerfectTruckAnalyticsSnapshot {
  activeTab: 'executive-overview' | 'location-summary';
  selectedRegions: any[];
  selectedMarkets: any[];
  selectedLocations: any[];
  selectedYears: any[];
  selectedPeriods: any[];
  selectedWeeks: any[];
  deliveryDateRange: { start: string | null; end: string | null };
  activeQuickSelect: string | null;
  selectedRouteTypes: any[];
  appliedFilterParams: any;
  manualBaselineParams: any;
}

interface PerfectTruckAnalyticsUiState {
  /**
   * True when the user navigated to the Perfect Truck module by clicking a
   * location name link in the Location Summary tab. Consumed once (read then
   * cleared) by the Perfect Truck module to decide whether to show the
   * "Perfect Truck Analytics > Perfect Truck" breadcrumb instead of the
   * default "Home > Perfect Truck" breadcrumb.
   */
  cameFromLocationLink: boolean;
  /**
   * True when the user clicked the "Perfect Truck Analytics" breadcrumb link
   * and the dashboard should restore `snapshot` on its next mount. Consumed
   * once (read then cleared) by the Perfect Truck Analytics dashboard.
   */
  restoreRequested: boolean;
  /**
   * Latest known filter/tab state of the Perfect Truck Analytics dashboard,
   * continuously mirrored while the dashboard is mounted so it can be
   * restored after the user navigates away (via the Perfect Truck breadcrumb)
   * and back.
   */
  snapshot: PerfectTruckAnalyticsSnapshot | null;
}

const initialState: PerfectTruckAnalyticsUiState = {
  cameFromLocationLink: false,
  restoreRequested: false,
  snapshot: null,
};

const perfectTruckAnalyticsUiSlice = createSlice({
  name: 'perfectTruckAnalyticsUi',
  initialState,
  reducers: {
    setCameFromLocationLink: (state, action: PayloadAction<boolean>) => {
      state.cameFromLocationLink = action.payload;
    },
    setRestoreRequested: (state, action: PayloadAction<boolean>) => {
      state.restoreRequested = action.payload;
    },
    saveSnapshot: (state, action: PayloadAction<PerfectTruckAnalyticsSnapshot>) => {
      state.snapshot = action.payload;
    },
    clearSnapshot: (state) => {
      state.snapshot = null;
    },
  },
});

export const { setCameFromLocationLink, setRestoreRequested, saveSnapshot, clearSnapshot } =
  perfectTruckAnalyticsUiSlice.actions;
export default perfectTruckAnalyticsUiSlice.reducer;
